export default __webpack_public_path__ + "static/media/smallcase-partner.11486c92.svg";